const { useReducer } = require("react");
const metaStateReducer = (metaState, action) => {
    switch (action.type) {
        case "SET_FINGERPRINT":{
            return { ...metaState, fingerprintId: action.payload };
          }
    }
}
export const useMetaState =()=>{
     const [metaState, dispatch] = useReducer(metaStateReducer, {
        fingerprintId: null, 
      });
      return [metaState, dispatch]
}